module.exports = __webpack_public_path__ + "static/media/25.6b2fc924.jpg";